import { Cookies } from "react-cookie";
import { COOKIE_DOMAIN } from "constants/cookies";

const cookies = new Cookies();

export const setChMobileCookie = () => {
  cookies.set("channel", "ch_mobile", { path: "/", expires: undefined, domain: COOKIE_DOMAIN });
};

export const getIsChMobileFromCookie = () => {
  return cookies.get("channel") === "ch_mobile";
};
